import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/** Para quem é o link de senha recebido por e-mail, se é convite ou redefinição e até quando vale. */
export interface LinkSenha { nome: string; email: string; tipo: 'CONVITE' | 'REDEFINICAO'; expiraEm: string; }

/** Mesmas regras do auth-service: mínimo de 6 caracteres e no máximo 72 (limite do BCrypt). */
export const SENHA_MINIMA = 6;
export const SENHA_MAXIMA = 72;

@Injectable({ providedIn: 'root' })
export class SenhaService {
    private http = inject(HttpClient);
    private base = `${environment.apiUrl}/auth`;

    /** Rotas públicas: o token vai no corpo, para não ficar nos logs de acesso. */
    consultarLink(token: string): Observable<LinkSenha> {
        return this.http.post<LinkSenha>(`${this.base}/redefinicao-senha/consultar`, { token });
    }

    definirPeloLink(token: string, novaSenha: string): Observable<void> {
        return this.http.post<void>(`${this.base}/redefinicao-senha`, { token, novaSenha });
    }

    /** Troca da própria senha, pelo usuário logado. */
    alterar(senhaAtual: string, novaSenha: string): Observable<void> {
        return this.http.put<void>(`${this.base}/senha`, { senhaAtual, novaSenha });
    }

    /** Administrador envia ao usuário o link de redefinição (ou de novo o convite). */
    redefinirUsuario(idUsuario: string, bloquearSenhaAtual: boolean): Observable<void> {
        return this.http.post<void>(`${this.base}/usuarios/${idUsuario}/redefinir-senha`, { bloquearSenhaAtual });
    }
}
